export const CertificateReplacement = 34;
export const DuplicateForSignature = 35;
export const Policy = 0;
export const Debt = 37;
export const Payment = 36;
